<script>
import {
  ArrowUpIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';
import VueEasyLightbox from "vue-easy-lightbox";
import MenuBar from './MenuBar.vue'
import html2canvas from "html2canvas";
import { Editor, EditorContent, FloatingMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Text from '@tiptap/extension-text'
import TextStyle from "@tiptap/extension-text-style";
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Placeholder from '@tiptap/extension-placeholder'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Youtube from '@tiptap/extension-youtube'
import Underline from '@tiptap/extension-underline'

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

// 초기세팅
function initialState() {
  return {
    appConfig: appConfig,
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    visible: false,
    currentIndex: 0,
    lightboximgs: [
      'images/_decen/sj.jpg',
    ],
    visibleFileList: false,
  };
}

export default {
  components: {
    VueEasyLightbox,
    ArrowUpIcon,
  },
  data() {
    return initialState();
  },
  props: {
    bi: {
      type: Number,
    },
    wi: {
      type: Number,
    },
    page: {
      type: Number,
    },
    baseInfo: {
      type: Object,
    },
    boardInfo: {
      type: Object,
    },
    latestData: {
      type: Array,
    },
    thisBoard: {
      type: Object,
    },
    writeData: {
      type: Object,
    },
    replyData: {
      type: Object,
    },
  },
  watch: {
    // 라우터 변경 시 metaInfo 업데이트
    $route() {
      this.updateMetaInfo();
    },
    // writeData가 변경될 때 metaInfo 업데이트 + 첨부파일 버튼 표시
    writeData: {
      handler(newVal) {
        if (newVal) {
          this.updateMetaInfo();
          this.visibleFileListCheck();
        }
      },
      deep: true,
      immediate: true
    },
    // writeData.subject가 변경될 때도 감시
    'writeData.subject': {
      handler(newVal) {
        if (newVal) {
          this.updateMetaInfo();
        }
      },
      immediate: true
    }
  },
  computed: {
    processedContent() {
      return this.addBrToEmptyParagraphs(this.writeData.contents);
    }
  },
  metaInfo() {
    // 기본값 먼저 설정 (데이터가 없어도 항상 반환)
    const defaultTitle = '대구여성인권센터';
    const defaultDescription = '대구여성인권센터';
    
    // writeData가 아직 로드되지 않았거나 status가 있으면 기본값 반환
    if (!this.writeData || !this.writeData.subject || this.writeData.status) {
      return {
        title: defaultTitle,
        meta: [
          {
            name: 'description',
            content: defaultDescription
          },
          {
            property: 'og:title',
            content: defaultTitle
          },
          {
            property: 'og:description',
            content: defaultDescription
          },
          {
            property: 'og:url',
            content: window.location.href
          },
          {
            name: 'twitter:title',
            content: defaultTitle
          },
          {
            name: 'twitter:description',
            content: defaultDescription
          }
        ]
      };
    }
    
    // 백엔드에서 데이터가 로드되면 업데이트된 값 반환
    const title = `${this.writeData.subject} | 대구여성인권센터`;
    
    // 게시글 제목
    const articleTitle = this.writeData.subject;
    
    // 게시글 설명 (내용의 일부 추출, HTML 태그 제거)
    let articleDescription = articleTitle;
    if (this.writeData.contents) {
      // HTML 태그 제거 및 텍스트만 추출
      if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.writeData.contents;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        articleDescription = textContent.substring(0, 200).trim() || articleTitle;
      } else {
        // SSR 환경에서는 간단한 정규식으로 처리
        articleDescription = this.writeData.contents.replace(/<[^>]*>/g, '').substring(0, 200).trim() || articleTitle;
      }
    }

    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: articleDescription
        },
        {
          property: 'og:title',
          content: articleTitle
        },
        {
          property: 'og:description',
          content: articleDescription
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: articleTitle
        },
        {
          name: 'twitter:description',
          content: articleDescription
        }
      ]
    };
  },
  mounted() {
    // 컴포넌트 마운트 시 metaInfo 업데이트
    this.updateMetaInfo();
  },
  created() {
    this.first()
  },
  methods: {
    // 처음에 실행되는 부분
    first() {
      // 사용자 정보 가져오자
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
    },
    // metaInfo 업데이트 메서드
    updateMetaInfo() {
      this.$nextTick(() => {
        // Vue Meta가 있으면 갱신
        if (this.$meta) {
          this.$meta().refresh();
        }
      });
    },
    // props로 받는 writeData를 확인해서 첨부파일 펼쳐보기 버튼 표시
    visibleFileListCheck() {
      // 자료실 게시판이라면 visibleFileList를 true로 설정
      if (this.bi==7 || this.bi==8) {
        this.visibleFileList = true
      } else {
        // this.writeData가 props에서 받아온 이후에만 실행
        if (this.writeData && this.writeData.file_json && this.writeData.file_json.length > 0) {
          // 이미지가 아닌 파일이 하나라도 있으면 첨부파일 펼쳐보기 버튼 표시
          const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'JPG', 'JPEG', 'PNG', 'GIF'];
          const hasNonImageFile = this.writeData.file_json.some(file => {
            const ext = typeof file === 'string'
              ? file.split('.').pop().toLowerCase()
              : (file && file.file_extension ? String(file.file_extension).toLowerCase() : '');
            return ext && !imageExtensions.includes(ext);
          });
          if (hasNonImageFile) {
            this.visibleFileList = true;
          }
        }
      }
    },
    convertToInlineStyles() {
      const container = this.$refs.contentContainer;
      const elements = container.querySelectorAll('*');

      elements.forEach(element => {
        const computedStyles = window.getComputedStyle(element);
        const inlineStyles = {};

        for (let i = 0; i < computedStyles.length; i++) {
          const cssProperty = computedStyles[i];
          inlineStyles[cssProperty] = computedStyles.getPropertyValue(cssProperty);
        }

        Object.assign(element.style, inlineStyles);
      });
    },
    handleImageClick(event) {
      if (event.target.tagName === 'IMG') {
        const imgs = Array.from(document.querySelectorAll('.tiptap img')).map(img => img.src);
        this.lightboximgs = imgs;
        this.currentIndex = imgs.indexOf(event.target.src);
        this.visible = true;
      }
    },
    // 빈 <p></p> 요소를 <p><br></p>로 대체
    addBrToEmptyParagraphs(html) {
      if (html) {
        return html.replace(/<p[^>]*><\/p>/g, '<p><br></p>');
      }
    },
    fileExtensionCheck(val) {
      // 파일 확장자 추출
      const fileExtension = val.split('.').pop().toLowerCase();
      // 이미지 파일 확장자 목록
      const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'JPG', 'JPEG', 'PNG', 'GIF'];
      if (imageExtensions.includes(fileExtension)) {
        return 'img'
      } else {
        return fileExtension
      }
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      if (val === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
    fileListImg(val) {
      return `${appConfig.fileserver}/${this.bi}/${this.wi}/${val}`;
    },
    fileDownload(val) {
      // 파일 확장자 추출
      const fileExtension = val.split('.').pop().toLowerCase();
      // 이미지 파일 확장자 목록
      const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'JPG', 'JPEG', 'PNG', 'GIF'];
      if (imageExtensions.includes(fileExtension)) {
        // 이미지 파일일 경우
        const downUrl = `${appConfig.fileserver}/${this.bi}/${this.wi}/${val}`;
        this.lightboximgs = downUrl
        this.currentIndex = 0
        this.visible = true;
      } else {
        // 이미지 파일이 아닌 경우 다운로드
        const downUrl = `${appConfig.fileserver}/${this.bi}/${this.wi}/${val}`;
        /*
        const link = document.createElement('a');
        link.href = downUrl;
        link.download = val;
        link.click();
        */
        var win = window.open(downUrl, '_blank');
        win.focus();
      }
    },
    thumnailLatest(val) {
      return `${appConfig.fileserver}/${this.bi}/${val}/thum.jpg?`+Date.now();
    },
    // 본문 이미지 프록시통해서 blob으로 변환
    async convertImageToBlob(imageUrl) {
      const proxyUrl = `${appConfig.fastapi}/board/proxy_converter?url=${encodeURIComponent(imageUrl)}`;
      const response = await fetch(proxyUrl);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    moveLink(val) {
      if (val=='m') {
        // 관리자면 프리패스
        if (this.login.level >=98) {
          // 수정페이지 이동
          this.$router.push({ path: `/jy/${this.bi}/m/${this.wi}` })
        } else {
          // 회원이 쓴거면
          if (this.writeData.mb_idx > 0) {
            if (this.login.idx == this.writeData.mb_idx) {
              this.$router.push({ path: `/jy/${this.bi}/m/${this.wi}` })
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: "본인이 쓴 글이 아닙니다."})
            }
          } else { // 비회원 글이라면
            // 제목이 "상담종료" 라면 글수정 안되게 처리
            if (this.writeData.subject=='상담종료') {
              alert('상담이 종료되어 글수정이 불가능합니다.')
            } else {
              // swal에서 비밀번호 받아오자
              this.$swal.fire({
                title: "비밀글",
                input: "text",
                inputLabel: "비밀번호를 입력해주세요",
                inputPlaceholder: "",
                inputAttributes: {
                  minlength: "6",
                  autocapitalize: "off",
                  autocorrect: "off",
                  autocomplete: "off", // 이렇게 해야 패스워드 저장 안됨 (안먹히는거같음)
                },
                customClass: {
                  input: 'password-field', // 이렇게 해야 패스워드 저장 안됨
                },
                confirmButtonText: "확인",
                validationMessage: "비밀번호는 최소 6글자 이상입니다.",
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value!==null && result.value!=='') {
                    // store에 게시글 수정한다고 정보전달하자
                    this.$store.commit('setBoardSecurity', {
                      "work": 'm',
                      "password": result.value,
                    });
                    // 수정페이지 이동
                    this.$router.push({ path: `/jy/${this.bi}/m/${this.wi}` })
                  }
                  
                }
              });
            }
          }
        }
      } else if (val=='d') { // 글 삭제
        // 관리자면 프리패스
        if (this.login.level >=98) {
          // 진짜 삭제할건지 묻고하자
          this.$swal.fire({
            title: '정말 삭제할건가요?',
            text: '다시 되돌릴 수 없습니다. 신중하세요.',
            icon: 'warning',
            showCancelButton: true, // cancel버튼 보이기. 기본은 원래 없음
            confirmButtonColor: '#ff0000', // confrim 버튼 색깔 지정
            cancelButtonColor: '#161c2d', // cancel 버튼 색깔 지정
            confirmButtonText: '삭제', // confirm 버튼 텍스트 지정
            cancelButtonText: '아니오', // cancel 버튼 텍스트 지정
            reverseButtons: false, // 버튼 순서 거꾸로
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed==true) {
                // 게시글삭제 실행하자
                this.deleteThisWrite("")
              }
            }
          });
        } else {
          // 회원이 쓴거면
          if (this.writeData.mb_idx > 0) {
            if (this.login.idx == this.writeData.mb_idx) {
              // 게시글삭제 실행하자
              this.deleteThisWrite("")
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: "본인이 쓴 글이 아닙니다."})
            }
          } else { // 비회원 글이라면
            // swal에서 비밀번호 받아오자
            this.$swal.fire({
              title: "비밀글",
              input: "text",
              inputLabel: "비밀번호를 입력해주세요",
              inputPlaceholder: "",
              inputAttributes: {
                minlength: "6",
                autocapitalize: "off",
                autocorrect: "off",
                autocomplete: "off", // 이렇게 해야 패스워드 저장 안됨 (안먹히는거같음)
              },
              customClass: {
                input: 'password-field', // 이렇게 해야 패스워드 저장 안됨
              },
              confirmButtonText: "확인",
              validationMessage: "비밀번호는 최소 6글자 이상입니다.",
            }).then((result) => {
              if (result.isConfirmed) {
                if (result.value!==null && result.value!=='') {
                  // 게시글삭제 실행하자
                  this.deleteThisWrite(result.value)
                }
              }
            });
          }
        }
      }
    },
    // 게시글 삭제 실행
    deleteThisWrite(value) {
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_board_delete_write',
        headers: {
          "access-token": this.token,
          "login-idx": this.login.idx,
          "password": value,
        },
        data: {
          "bi": this.bi,
          "wi": this.wi,
        },
      })
      .then((res) => {
        if (res.data) {
          if (res.data.status =='success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '삭제완료', text: res.data.text})
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': '정보반환 실패', text: res.data.text})
          }
        }
      })
      .catch((error) => {
        console.log(error)
        if (error.response) {
          this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
        }
        if (error.code=='ERR_NETWORK') {
          console.log(error.message)
          this.$notify({ type: 'error', duration: 3000, 'title': '서버오류', text: error.message})
        }
      })
      .finally(()=> {
        // 목록으로
        this.$router.push({ path: `/jy/${this.bi}` })
      })
    },
    // 종료 (자료파기)
    completeThisWrite(val) {
      if (val=='complete') {
        // 관리자면 프리패스
        if (this.login.level >=98) {
          // 진짜 삭제할건지 묻고하자
          this.$swal.fire({
            title: '정말 이 글을 폭파할건가요?',
            text: '다시 되돌릴 수 없습니다. 신중하세요.',
            icon: 'warning',
            showCancelButton: true, // cancel버튼 보이기. 기본은 원래 없음
            confirmButtonColor: '#ff0000', // confrim 버튼 색깔 지정
            cancelButtonColor: '#161c2d', // cancel 버튼 색깔 지정
            confirmButtonText: '파기실행', // confirm 버튼 텍스트 지정
            cancelButtonText: '아니오', // cancel 버튼 텍스트 지정
            reverseButtons: false, // 버튼 순서 거꾸로
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed==true) {
                // 자료파기 실행
                this.secretComplete()
              }
            }
          });
        }
      }
    },
    // 답변 저장하기 (수정하기)
    sendReply() {
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_board_sendReply',
        headers: {
          'access-token': this.token
        },
        data: {
          "mb_id": this.login.idx,
          "mb_nick": this.login.nick,
          "bi": this.bi,
          "wi": this.wi,
          "contents": this.replyData.contents,
        },
      })
      .then((res) => {
        if (res.data.type == 'success') {
          this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '저장되었습니다.'})
        } else {
          this.$notify({ type: 'error', duration: 3000, 'title': res.data.type+' 에러', text: res.data.message })
        }
      })
      .catch((error) => {
        console.log(error)
        if (error.response) {
          this.$notify({ type: 'error', duration: 3000, 'title': error.response.type+' 에러', text: error.response.data.detail })
        }
      })
      .finally(() => {
      })
    },
    // 비밀글 완료처리
    secretComplete() {
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_board_secret_complete',
        headers: {
          "access-token": this.token,
          "login-idx": this.login.idx,
        },
        data: {
          "bi": this.bi,
          "wi": this.wi,
        },
      })
      .then((res) => {
        if (res.data) {
          if (res.data.status =='success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '자료파기 완료', text: res.data.text})
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': '정보반환 실패', text: res.data.text})
          }
        }
      })
      .catch((error) => {
        console.log(error)
        if (error.response) {
          this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
        }
        if (error.code=='ERR_NETWORK') {
          console.log(error.message)
          this.$notify({ type: 'error', duration: 3000, 'title': '서버오류', text: error.message})
        }
      })
      .finally(()=> {
        // 목록으로
        this.$router.push({ path: `/jy/${this.bi}` })
      })
    },
    // 연혁 추가하기
    modalTimeline() {
      var imgUrl = ""
      if (this.writeData.is_thum==1) {
        imgUrl = `${appConfig.fileserver}/${this.bi}/${this.writeData.idx}/thum.jpg`
      }
      const obj = {
        "idx": 0,
        "contents": this.writeData.subject,
        "start": String(this.writeData.insert_time.split(" ")[0]), // string으로 바꿔주자 (YYYY-MM-DD)
        "end": "",
        "imgUrl": imgUrl,
        "linkUrl": window.location.href,
        "thum": "",
        "pinDate": String(this.writeData.insert_time.split(" ")[0]),
        "boardFiles": this.writeData.file_json ? this.writeData.file_json : [],
        "year": this.writeData.insert_time.split("-")[0],
      }
      // boardAdd
      this.$store.commit('setModal_lgVal', obj); // store.js 로 보내주자
      this.$store.commit('setModal_lgWorker', 'boardAdd'); // store.js 로 보내주자
      this.$root.$emit('bv::toggle::modal', 'modal_lg'); // 모달 오픈
    },
  },
}
</script>

<template>
  <div v-if="!writeData.status" class="row">
    <!-- 이미지 크게 -->
    <vue-easy-lightbox :visible="visible" :index="currentIndex" :imgs="lightboximgs" scrollDisabled='false' @hide="visible = false"></vue-easy-lightbox>
    <!-- 게시글 영역 -->
    <div class="col-lg-9 col-md-12 col-sm-12">
      <div class="card mb-2">
        <!-- 리본 -->
        <div v-if="thisBoard.jsonData" class="ribbon ribbon-left ribbon-primary overflow-hidden">
          <span class="text-center d-block shadow small h6">
            {{ thisBoard.jsonData.name }}
          </span>
        </div>
        <!-- 페이지 가운데로 이동은 justify-content-center -->
        <div v-if="thisBoard.jsonData" class="d-flex align-items-right justify-content-between p-2">
          <div class="">
          </div>
          <div class="">
            <ul class="pagination mb-0">
              <li class="page-item">
                <router-link :to="`/jy/${this.bi}`">
                  <span class="page-link"><i class="mdi mdi-form-select text-warning mr-1"></i>목록</span>
                </router-link>
              </li>
              <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
                <router-link :to="`/jy/${this.bi}/w`">
                  <span class="page-link"><i class="mdi mdi-lead-pencil text-info mr-1"></i>쓰기</span>
                </router-link>
              </li>
              <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
                <div @click="moveLink('m')" class="cursor-pointers">
                  <span class="page-link"><i class="mdi mdi-lead-pencil text-blue mr-1"></i>수정</span>
                </div>
              </li>
              <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
                <div @click="moveLink('d')" class="cursor-pointers">
                  <span class="page-link"><i class="mdi mdi-lead-pencil text-danger mr-1"></i>삭제</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 게시물 영역 -->
        <div class="p-2">
          <div v-if="thisBoard.jsonData" class="">

            <!-- 임시저장 게시글이면 -->
            <div v-if="writeData.is_temp_save == true" class="bg-soft-danger text-center text-danger h3 mb-3 p-3">
              <i class="mdi mdi-file-outline text-danger mr-1"></i>임시저장 게시글입니다. (관리자만 보여요)
            </div>
            
            <!-- 글쓴이, 작성일시, 제목 등 -->
            <div class="card">
              <div class="card-body">
                <div class="text-bold font-size-18 text-dark mb-1">{{ writeData.subject }}</div>
                <div class="d-flex align-items-right justify-content-between text-secondary font-size-10">
                  <span class="font-size-13 text-bold text-secondary">
                    <i class="mdi mdi-heart text-danger mr-1"></i>
                    <b class="text-dark">{{ writeData.writer }}</b>
                  </span>
                  <span class="">
                    <span v-if="thisBoard.jsonData.use_secret==false" class="">
                      <i class="mdi mdi-eye text-info mr-1"></i><b class="mr-2">{{ writeData.hit }}</b>
                    </span>
                    <span>
                      <i class="mdi mdi-clock-outline ml-1"></i> <b>{{ writeData.insert_time }}</b>
                    </span>
                  </span>
                </div>
                <!-- 비밀글 게시판의경우 -->
                <div v-if="thisBoard.jsonData.use_secret==true" class="d-flex align-items-right justify-content-between text-secondary font-size-10">
                  <span class="font-size-13 text-bold text-secondary"><b class="text-info">{{ writeData.wr_phone }}</b></span>
                  <span class="font-size-13 text-bold text-secondary"><b class="text-danger">{{ writeData.wr_email }}</b></span>
                </div>
                
                
              </div>
            </div>
          </div>
        </div>
        
        <!-- 파일 리스트 -->
        <div v-if="writeData.file_json" class="">
          <div v-if="writeData.file_json.length > 0" class="border-top">
            <div v-if="!visibleFileList" @click="visibleFileList = true" class="text-secondary cursor-pointer font-size-12 text-center">
              <i class="mdi mdi-chevron-down mr-1"></i> 첨부파일 펼쳐보기
            </div>
            <div v-if="visibleFileList" @click="visibleFileList = false" class="text-secondary cursor-pointer font-size-12 text-center">
              <i class="mdi mdi-chevron-up mr-1"></i> 첨부파일 접기
            </div>
          </div>
          <div v-if="visibleFileList" class="">
            <ul class="list-unstyled p-2 mb-0">
              <li v-for="(value, key) in writeData.file_json" :key="key" class="list-inline-item">
                <div v-if="fileExtensionCheck(value) !=='img'" class="mr-1">
                  <b-button @click="fileDownload(value)" class="btn btn-sm btn-block btn-square btn-light font-size-10 ">
                    <div v-b-tooltip.hover :title="value" class="mx-auto d-block text-blue">
                      <div>
                        <i class="mdi mdi-link-variant"></i> 
                        <span class="text-blue">{{ key+1 }}. {{ fileExtensionCheck(value) }}파일</span>
                        <span class="font-size-10 text-muted ml-1">({{ value }})</span>
                      </div>
                    </div>
                  </b-button>
                </div>
                <div v-if="fileExtensionCheck(value) =='img'" class="mr-1">
                  <b-button @click="fileDownload(value)" class="btn btn-sm btn-block btn-soft-light font-size-10">
                    <div v-b-tooltip.hover :title="value" class="mx-auto d-block">
                      <div>{{ key+1 }}. 이미지파일</div>
                    </div>
                  </b-button>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 관리자 영역 -->
        <div v-if="login.level >= 98" class="">
          <div v-if="thisBoard.jsonData" class="p-2 border-top">
            <!-- 글쓴이, 작성일시, 제목 등 -->
            <div class="row">
              <div class="col-xl-3">
                <!-- 비밀글 상담종료처리 -->
                <div v-if="thisBoard.jsonData.use_secret==true">
                  <b-button @click="completeThisWrite('complete')" class="btn btn-sm btn-block btn-warning font-size-10">
                    <i class="mdi mdi-bomb mr-1"></i>종료 (게시글폭파)
                  </b-button>
                </div>
                <!-- 연혁에 추가 -->
                <div v-if="thisBoard.jsonData.use_secret==false">
                  <b-button @click="modalTimeline()" class="btn btn-sm btn-block btn-light font-size-10">
                    <i class="mdi mdi-book-edit mr-1"></i>게시판에서 연혁추가
                  </b-button>
                </div>
              </div>
              <div class="col-xl-9 text-right font-size-10">
                <i class="mdi mdi-blur mr-1"></i>글쓴이 IP : <b class="text-warning">{{ writeData.mb_ip }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 본문 -->
      <div class="editor read-tiptap mb-4">
        <div ref="contentContainer" class="editor-main">
          <div v-html="processedContent" class="tiptap" @click="handleImageClick"></div>
        </div>
      </div>

      <!-- 답변  (비밀글게시판만 해당)-->
      <div v-if="thisBoard">
        <div v-if="thisBoard.jsonData">
          <div v-if="thisBoard.jsonData.use_secret==true">
            <!-- 답변이 있으면 -->
            <div v-if="replyData.mb_nick" class="card border-primary mb-4">
              <div class="card-header bg-soft-blue">
                <div class="d-flex align-items-right justify-content-between">
                  <div class="text-bold">답변</div>
                </div>
              </div>
              <div class="card-body">
                <div class="">
                  <label>상담사: <b class="text-primary">{{ replyData.mb_nick }}</b></label>
                  <div class="position-relative">
                    <b-form-textarea 
                      id="textarea-plaintext" 
                      :readOnly="login.level < thisBoard.jsonData.lv_reply" 
                      class="reply-form font-size-15"
                      v-model="replyData.contents"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <!-- 관리자라면 답변 저장 -->
                <div v-if="login.level >= thisBoard.jsonData.lv_reply" class="">
                  <b-button @click="sendReply()" class="btn btn-block btn-primary">답변 저장</b-button>
                </div>
              </div>
            </div>
            <!-- 관리자인데 답변아직없으면 -->
            <div v-else class="card border-primary mb-4">
              <div class="card-header bg-soft-blue">
                <div class="text-bold">답변</div>
              </div>
              <div v-if="login.level >= thisBoard.jsonData.lv_reply" class="card-body">
                <div class="">
                  <label>답변자: <b class="text-primary">{{ login.nick }}</b></label>
                  <div class="position-relative">
                    <b-form-textarea 
                      id="textarea-plaintext" 
                      :readOnly="login.level < thisBoard.jsonData.lv_reply" 
                      class="reply-form font-size-15"
                      v-model="replyData.contents"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <!-- 답변 아직 없음 -->
              <div v-else class="card-body">
                <div class="">
                  <div class="position-relative">
                    상담사가 아직 확인 전입니다. 잠시만 기다려주세요
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <!-- 관리자라면 답변 최초달자 -->
                <div v-if="login.level >= thisBoard.jsonData.lv_reply" class="">
                  <b-button @click="sendReply()" class="btn btn-block btn-primary">답변 저장</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 페이지 가운데로 이동은 justify-content-center -->
      <div v-if="thisBoard.jsonData" class="d-flex align-items-right justify-content-between p-2">
        <div class="">
        </div>
        <div class="">
          <ul class="pagination mb-0">
            <li class="page-item">
              <router-link :to="`/jy/${this.bi}`">
                <span class="page-link"><i class="mdi mdi-form-select text-warning mr-1"></i>목록</span>
              </router-link>
            </li>
            <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
              <router-link :to="`/jy/${this.bi}/w`">
                <span class="page-link"><i class="mdi mdi-lead-pencil text-info mr-1"></i>쓰기</span>
              </router-link>
            </li>
            <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
              <div @click="moveLink('m')" class="cursor-pointers">
                <span class="page-link"><i class="mdi mdi-lead-pencil text-blue mr-1"></i>수정</span>
              </div>
            </li>
            <li v-if="login.level >= thisBoard.jsonData.lv_write" class="page-item">
              <div @click="moveLink('d')" class="cursor-pointers">
                <span class="page-link"><i class="mdi mdi-lead-pencil text-danger mr-1"></i>삭제</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 우측 사이드바 시작 -->
    <div v-if="thisBoard.jsonData" class="col-lg-3 col-md-12 col-sm-12 mb-2">


      <div v-if="thisBoard.jsonData" class="card sidebar sticky-bar p-4">
        <div class="widget mb-4 pb-2">
          
          <!-- 게시판 메뉴 -->
          <h5 class="widget-title">게시판</h5>
          <ul v-if="boardInfo" class="list-unstyled mb-4">
            <li v-for="(value, key) in boardInfo[thisBoard.jsonData.group]" :key="key" class="cursor-pointer mb-1">
              <router-link :to="`/jy/${value.idx}`" class="accounts d-block text-center unselected-menu rounded text-dark p-2" :class="{'active selected-menu ':thisBoard.jsonData.name == value.contents.name}">
                <span class="title text-dark h6">
                  {{ value.contents.name }}
                </span>
              </router-link>
            </li>
          </ul>

          <!-- 최근 게시글 -->
          <div v-if="thisBoard.jsonData.use_latest==true" class="widget pb-2">
            <h5 class="widget-title">최근 게시글</h5>            
            <div v-for="(value, key) in latestData" :key="key" class="pt-1 pb-1 border-top clearfix board-recent">
              <router-link :to="`/jy/${thisBoard.idx}/r/${value.idx}`">
                <!-- 썸네일 있으면 이미지처리-->
                <div v-if="value.is_thum == true" class="board-recent-thumb float-left list-latestthum">
                  <img :src="thumnailLatest(value.idx)" alt="img" class="border rounded">
                </div>
                <!-- 썸네일 있으면 제목 -->
                <div v-if="value.is_thum == true" class="board-recent-content float-left">
                  <div class="text-overflow120">
                    <span class="text-bold">{{ value.subject}}</span> 
                  </div>
                  <div class="board-meta d-flex justify-content-between">
                    <span class="text-muted font-size-11">{{ value.insert_time}}</span>
                  </div>
                </div>
                <!-- 썸네일 없으면 제목 -->
                <div v-else class="board-recent-content full float-left">
                  <div class="text-overflow180">
                    <span class="text-bold">{{ value.subject}}</span> 
                  </div>
                  <div class="board-meta d-flex justify-content-between">
                    <span class="text-muted font-size-11">{{ value.insert_time}}</span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- 권한 없으면 -->
  <div v-else class="card">
    <div class="card-body">
      <h5 class="text-danger text-bold">{{ writeData.error }}</h5>
    </div>
  </div>
</template>